import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0ff8bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialogvisible-content" }
const _hoisted_2 = { class: "content-table" }
const _hoisted_3 = { class: "total-info" }
const _hoisted_4 = { class: "order-type" }
const _hoisted_5 = { class: "orange" }
const _hoisted_6 = {
  key: 0,
  style: {"margin-left":"10px"},
  class: "extended-trade"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-th" }, [
  /*#__PURE__*/_createElementVNode("span", null, "姓名/账户"),
  /*#__PURE__*/_createElementVNode("span", null, "委托数量"),
  /*#__PURE__*/_createElementVNode("span", null, "价格")
], -1))
const _hoisted_8 = { class: "table-th table-tb" }
const _hoisted_9 = {
  key: 0,
  class: "red-tip"
}
const _hoisted_10 = {
  key: 0,
  class: "tips-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisibleFlag,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisibleFlag) = $event)),
    width: "600px",
    title: _ctx.title,
    "destroy-on-close": true,
    center: "",
    "show-close": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "content-close",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        loading: _ctx.buyLoading,
        class: "content-confirm",
        onClick: _ctx.confirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(" 以下每个账户将以" + _toDisplayString(_ctx.showPrice), 1),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.tradingObj.entrustBs === '买入' ? 'orange' : 'blue')
            }, _toDisplayString(_ctx.tradingObj.entrustBs), 3),
            _createTextVNode(_toDisplayString(_ctx.tradingObj.stockName) + "(" + _toDisplayString(_ctx.tradingObj.stockCode) + "." + _toDisplayString(_ctx.tradingObj.exchangeType) + "),总金额" + _toDisplayString(_ctx.totalAmount), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" 订单类型："),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.tradingObj.entrustProp), 1),
            (
              _ctx.tradingObj.extendedTrading && _ctx.tradingObj.exchangeType === 'US'
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "盘前盘后"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7,
          _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, { class: "scroll-wrapper" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(item.nameCn) + " / " + _toDisplayString(item.fundAccount), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.numFormat(item.num, 0)), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.price
                  ? _ctx.numFormat(Number(_ctx.price), _ctx.price.split(".")[1]?.length)
                  : "- -"), 1)
                  ]),
                  (item.tips)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.tips), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        (!_ctx.tableData.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 注：账户排序顺序即为下单顺序，具体以成交为准 "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}